module.exports = __webpack_public_path__ + "media/images/sp/shop/step-01-a655548236868830dcee2187708e3e3a.png";